/**
 * Reports whether the given generation schema disables its polycount control
 * while smart low poly is on. A provider opts into disabling by flagging its
 * polycount key (`face_count` or `target_polycount`) as `false` in the
 * `smart_low_poly: true` allOf branch. Providers whose low-poly model takes a
 * face count (meshy T2, tripo3d P1) simply omit that flag, which keeps the
 * control editable against the branch's own range.
 *
 * @param {Object} generationModelSchema - The active generation model schema.
 * @returns {boolean} True when polycount should be disabled under smart low poly.
 */
export function isPolycountDisabledForSmartLowPoly(generationModelSchema) {
  const allOf = generationModelSchema?.input_schema?.allOf || []

  return allOf.some((entry) => {
    if (entry?.if?.properties?.smart_low_poly?.const !== true) {
      return false
    }

    const thenProperties = entry?.then?.properties || {}

    return thenProperties.face_count === false || thenProperties.target_polycount === false
  })
}
